import { useLogout } from '@privy-io/react-auth';
import { PublicKey } from '@solana/web3.js';
import { useEffect } from 'react';
import useWalletContext from 'src/hooks/useWalletContext';
import { useAppInitialLoadContext } from 'src/providers/app/AppInitialLoadProvider/AppInitialLoadProvider';
import { usePrivyWalletContext } from 'src/providers/wallets/PrivyWalletProvider';

/**
 * Logs out from Privy if the connected Solana Wallet Adapter is a different wallet address
 * used to authenticate with Privy.
 */
export const useSyncPrivyLogout = () => {
	const { user, sessionMode, solanaWalletAuthorityForPrivyUser } =
		usePrivyWalletContext();
	const { logout: privyLogout } = useLogout();
	const walletContext = useWalletContext();
	const { isInitialLoading } = useAppInitialLoadContext();

	useEffect(() => {
		if (isInitialLoading) {
			return;
		}

		const isEoaLinkedPrivySession = sessionMode === 'eoa-linked';

		const walletNotConnectedButPrivyIsAuthenticated =
			isEoaLinkedPrivySession &&
			!walletContext.wallet?.adapter?.publicKey &&
			!!user;

		const connectedWalletAddressDifferentFromPrivyUser =
			isEoaLinkedPrivySession &&
			walletContext.wallet?.adapter?.publicKey &&
			solanaWalletAuthorityForPrivyUser &&
			!walletContext.wallet.adapter.publicKey.equals(
				new PublicKey(solanaWalletAuthorityForPrivyUser)
			);

		if (
			walletNotConnectedButPrivyIsAuthenticated ||
			connectedWalletAddressDifferentFromPrivyUser
		) {
			privyLogout();
		}
	}, [
		walletContext.wallet?.adapter?.publicKey,
		user,
		sessionMode,
		solanaWalletAuthorityForPrivyUser,
		isInitialLoading,
		privyLogout,
	]);
};
